import { SDS } from '@schibsted-ufo/ui-components';
import styled, { keyframes } from 'styled-components';
import { breakpoints } from '@vNext/theme/tools/breakpoints';

const toastFadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const StyledToastContainer = styled.ol`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 0;
    position: fixed;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 95%;
    z-index: 1;

    @media (min-width: ${breakpoints.lg}) {
      max-width: 1020px;
    }
`;

export const StyledToast = styled(SDS.Toast)`
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.1),
    0 2px 4px rgba(0, 0, 0, 0.1);
  animation: ${toastFadeIn} 300ms ease forwards;

  > span {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 4px 0;
  }

  @media (prefers-reduced-motion) {
    animation: none !important;
  }
`;

export const StyledMessage = styled.div`
  display: grid;
  gap: 4px;
  flex: 1;
`;

export const StyledCloseButton = styled(SDS.Icon)`
  cursor: pointer;
  width: 24px;
`;
